import { SelectItem } from '@/types';
import { enumController } from '../core';
import { formatTitleCase } from '@/features/campaigns/utils';

export const getRcsBillingCategoryOptions = async () => {
  const categories = await enumController.getRcsBillingCategories();
  return categories.map((category) => ({
    label: formatTitleCase(category),
    value: category,
  }));
};

export const getRejectionCategoryOptions = async (): Promise<SelectItem[]> => {
  const response = await enumController.getRejectionCategories();
  return response.map((category) => ({
    label: category.name,
    value: category.id,
  }));
};

export const getSuspensionCategoryOptions = async (): Promise<SelectItem[]> => {
  const response = await enumController.getSuspensionCategories();
  return response.map((category) => ({
    label: category.name,
    value: category.id,
  }));
};

export const getUseCaseOptions = async () => {
  const useCases = await enumController.getUseCaseTypes({ channelId: '10DLC' });
  return useCases.map((useCase) => ({
    label: useCase.displayName,
    value: useCase.id,
  }));
};

export const getRcsUseCaseOptions = async () => {
  const useCases = await enumController.getUseCaseTypes({ channelId: 'RCS' });
  return useCases.map((useCase) => ({
    label: useCase.displayName,
    value: useCase.id,
  }));
};

export const getRcsHostingRegionOptions = async () => {
  const useCases = await enumController.getRcsHostingRegions();
  return useCases.map((region) => ({
    label: formatTitleCase(region),
    value: region,
  }));
};
